import { faPlus } from '@fortawesome/pro-regular-svg-icons';
import { DataTestIdEnum } from '@medprev-web-app/datatestid';
import { Activity } from 'react';

import { Button } from '@/components/ui/button/button.component';
import { Card } from '@/components/ui/card.component';
import { Link } from '@/components/ui/link/link.component';
import { Typography } from '@/components/ui/typography/typography.component';
import { TypographyVariant } from '@/components/ui/typography/typography.type';
import { formatToTitleCase } from '@/utils/formatters/format-to-title-case';
import { IndexItem } from '@/types/index/index-list.type';
import { AnalyticsEnum } from '@/types/enums/analytics/analytics.enum';

export function SeoExamCityCard({ exam, isFirst = false }: { exam: IndexItem; isFirst?: boolean }) {
  const keyUrl = `/exames/por-exame/${exam?.slug}/${String(exam.cities?.[0].state_abbr).toLowerCase()}/`;

  return (
    <Card className={`md:mt-6 pt-0 border-x-0 sm:px-16 ${isFirst ? 'border-t' : 'border-t-0'} md:px-6 md:border-t md:border-b md:border-x rounded-none md:rounded-xl`}>
      <Link
        prefetch={false}
        href={keyUrl}
        data-testid={DataTestIdEnum.INDEX_LINK_BY_HEADER_NAME}
        className="bg-green-100 hover:bg-green-200 text-gray-700 rounded-b w-fit flex items-center px-5 py-1 hover:underline"
        data-analytics-event={AnalyticsEnum.CLICK_TITLE_STATE_IN_EXAM_CARD}
        data-analytics-properties={JSON.stringify({ estado_nome: exam.cities?.[0].state_abbr, exame_nome: exam.name })}
      >
        <Typography
          variant={TypographyVariant.MEDIUM_BODY_TEXT}
          className="font-semibold"
        >
          {exam.key}
        </Typography>
      </Link>

      <ul className="mt-4 space-y-4">
        {exam?.cities?.map((city) => (
          <li key={city?.slug}>
            <Link
              prefetch={false}
              className="text-green-500 font-bold hover:underline"
              href={`/exames/${exam?.slug}-em-${city?.slug}/`}
              data-testid={DataTestIdEnum.INDEXING_CARD_CITY_NAME}
              data-analytics-event={AnalyticsEnum.CLICK_EXAM_BY_CITY}
              data-analytics-properties={JSON.stringify({ exame: exam.name, cidade: city.city, estado: city.state_abbr })}
            >
              {`${formatToTitleCase(String(exam?.name))} em ${city?.city} - ${city?.state_abbr}`}
            </Link>
            <hr className="mt-4" />
          </li>
        ))}
      </ul>

      <Activity mode={(exam?.cities?.length ?? 0) > 4 ? 'visible' : 'hidden'}>
        <Link
          prefetch={false}
          data-testid={DataTestIdEnum.INDEXING_CARD_SEE_MORE}
          data-analytics-key={exam.key}
          href={keyUrl}
          data-analytics-event={AnalyticsEnum.CLICK_SEE_EVERY_EXAM_BY_UF_BY_EXAM_CARD}
          data-analytics-properties={JSON.stringify({ exame: exam.name, estado: exam.cities?.[0].state_abbr })}
        >
          <Button
            variant="text"
            className="w-fit mt-4 font-bold"
            startIcon={faPlus}
          >
            Ver mais
          </Button>
        </Link>
      </Activity>
    </Card>
  );
}
